import { UnifiedOnboardingUpsellOfferKind } from '@src/types'

export const SUPPORTED_UPSELL_KINDS = [
  UnifiedOnboardingUpsellOfferKind.UpgradeSubscription,
  UnifiedOnboardingUpsellOfferKind.NutritionAppointment,
  UnifiedOnboardingUpsellOfferKind.StressManagementAppointment,
  UnifiedOnboardingUpsellOfferKind.LabPanels,
  UnifiedOnboardingUpsellOfferKind.SteloCgm,
  UnifiedOnboardingUpsellOfferKind.ReferAFriend,
]
